import axios from 'axios';

// const api = axios.create({
//   baseURL: process.env.REACT_APP_API_BASE || '/api/v1',
//   timeout: 10000,
//   headers: {
//     'Content-Type': 'application/json',
//   },
// });


// const api = axios.create({
//   baseURL: process.env.NODE_ENV === 'development' ? 'http://localhost:15301/api/v1' : 'https://template.rajoffset.com/api/v1',
//   timeout: 120000, // Increased to 120 seconds for background removal processing
//   headers: {
//     'Content-Type': 'application/json',
//   },
// });


// const api = axios.create({
//   baseURL: 'https://template.rajoffset.com/api/v1',
//   timeout: 1200000,
//   headers: {
//     'Content-Type': 'application/json',
//   },
// });

const api = axios.create({
  baseURL: '/api/v1',
  timeout: 1200000,
  headers: {
    'Content-Type': 'application/json',
  },
});


// Add request interceptor to include auth token AND normalize trailing slashes for collection POSTs
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Add tenant ID header (you can customize this based on your tenant logic)
    config.headers['x-tenant-id'] = 'default';

    // Normalize trailing slash for collection-level POST/PUT endpoints to avoid 405
    // If URL has a single path segment like "/categories" or "/tenants", append "/"
    try {
      const url = config.url || '';
      const method = (config.method || 'get').toLowerCase();
      const isSingleSegment = /^\/[a-z0-9-]+$/i.test(url);
      if ((method === 'post' || method === 'put') && isSingleSegment && !url.endsWith('/')) {
        config.url = `${url}/`;
      }
    } catch (_) {}

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle errors
api.interceptors.response.use(
  (response) => {
    // Backward compatibility: expose boolean success even if API now returns status="success".
    if (response?.data && typeof response.data === 'object' && !Array.isArray(response.data)) {
      if (typeof response.data.success === 'undefined' && typeof response.data.status === 'string') {
        response.data.success = response.data.status.toLowerCase() === 'success';
      }
    }
    return response;
  },
  (error) => {
    // Keep error payload shape consistent for callers that inspect success on error responses.
    if (error?.response?.data && typeof error.response.data === 'object' && !Array.isArray(error.response.data)) {
      if (typeof error.response.data.success === 'undefined' && typeof error.response.data.status === 'string') {
        error.response.data.success = error.response.data.status.toLowerCase() === 'success';
      }
    }

    if (error.response?.status === 401) {
      // Handle unauthorized access
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('tokenExpiry');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Template API
export const templateAPI = {
  getAll: (params = {}) => api.get('/templates', { params }),
  getById: (id) => api.get(`/templates/${id}`),
  getCategories: () => api.get('/templates/categories'),
  create: (data) => api.post('/templates', data),
  // Create a template WITH template_content; the backend creates it with
  // stage='processing' and runs bulk AI image generation in the background,
  // flipping stage to 'pending' (or 'failed') when done.
  createWithContent: (data) => api.post('/templates/create-with-content', data),
  // Run bulk AI image generation for an existing template (editor action).
  // Persists the passed template_content, sets stage='processing', and runs the
  // resilient callback-driven generation tracked in the Progress queue.
  bulkAIGenerate: (id, data) => api.post(`/templates/${id}/bulk-ai-generate`, data),
  // Generate a single image item via the Progress queue (per-element action).
  // data: { template_content, page_index, item_index }
  aiGenerateItem: (id, data) => api.post(`/templates/${id}/ai-generate-item`, data),
  // Retry a FAILED AI generation record from the AI Generation Queue dialog.
  aiRetryJob: (id, aiJobId) => api.post(`/templates/${id}/ai-retry-job/${aiJobId}`),
  update: (id, data) => api.put(`/templates/${id}`, data),
  updateConfig: (id, data) => api.put(`/templates/${id}/config`, data),
  updateType: (id, type) => api.put(`/templates/${id}/type`, { type }),
  updateStage: (id, data) => api.put(`/templates/${id}/stage`, data),
  delete: (id) => api.delete(`/templates/${id}`),
  check: (id) => api.get(`/templates/check/${id}`),
  save: (data) => {
    if (data.id) {
      return api.post(`/templates/save?id=${data.id}`, data)
    } else {
      alert('No template ID provided. Please contact support.')
      return Promise.reject(new Error('No template ID provided. Please contact support.'))
    }
  },
  getMyTemplates: (params = {}) => api.get('/templates/my-templates', { params }),
  getCategoryFields: (id) => api.get(`/templates/${id}/category-fields`),
  generateSample: (id) => api.post(`/templates/${id}/generate-sample`),

  // Template actions
  clone: (id, data = {}) => api.post(`/templates/${id}/clone`, data),

  // Sample generation
  generate9Samples: (id, data) => api.post(`/templates/${id}/generate-9-samples`, data),

  // Dashboard analytics
  getDesignCounts: (params) => api.get('/templates/design-counts', { params }),
  getDesignsByDate: (params) => api.get('/templates/designs-by-date', { params }),
  getCalendarData: (params) => api.get('/templates/calendar-data', { params }),
  getCombinedCalendarData: (params) => api.get('/templates/calendar-data', { params: { ...params, include_events: true } }),

  // Calendar events
  getCalendarEvents: (params) => api.get('/calendar/events', { params }),
  getTodayEvents: () => api.get('/calendar/events/today'),
  getTomorrowEvents: () => api.get('/calendar/events/tomorrow'),
  getUpcomingEvents: (days = 7) => api.get(`/calendar/events/upcoming?days=${days}`),
  getOverdueEvents: () => api.get('/calendar/events/overdue'),
  getCalendarEvent: (id) => api.get(`/calendar/events/${id}`),
  createCalendarEvent: (data) => api.post('/calendar/events', data),
  updateCalendarEvent: (id, data) => api.put(`/calendar/events/${id}`, data),
  deleteCalendarEvent: (id) => api.delete(`/calendar/events/${id}`),
  getCalendarStats: (days = 30) => api.get(`/calendar/events/stats/summary?days=${days}`),
  getTemplateEvents: (templateId) => api.get(`/calendar/events/template/${templateId}`),

  // Global Field Samples
  getGlobalFieldSamples: (globalFieldId, params) => api.get(`/global-field-samples/field/${globalFieldId}`, { params }),
  getGlobalFieldSamplesPaginated: (globalFieldId, params) => api.get(`/global-field-samples/field/${globalFieldId}/paginated`, { params }),
  createGlobalFieldSample: (data) => api.post('/global-field-samples/', data),
  bulkCreateGlobalFieldSamples: (data) => api.post('/global-field-samples/bulk', data),
  updateGlobalFieldSample: (id, data) => api.put(`/global-field-samples/${id}`, data),
  deleteGlobalFieldSample: (id) => api.delete(`/global-field-samples/${id}`),
  searchGlobalFieldSamples: (params) => api.get('/global-field-samples/search', { params }),
  getPopularGlobalFieldSamples: (params) => api.get('/global-field-samples/popular', { params }),
  getRecentGlobalFieldSamples: (params) => api.get('/global-field-samples/recent', { params }),
  incrementGlobalFieldSampleUsage: (id) => api.post(`/global-field-samples/${id}/increment-usage`),
  getGlobalFieldSampleLanguages: (globalFieldId) => api.get(`/global-field-samples/field/${globalFieldId}/languages`),
  getGlobalFieldSampleCategories: (globalFieldId) => api.get(`/global-field-samples/field/${globalFieldId}/categories`),
  getGlobalFieldSampleStatistics: (params) => api.get('/global-field-samples/statistics', { params }),

  // Bulk operations
  bulkUpdate: (data) => api.put('/templates/bulk/update', data),
  bulkGenerateSamples: (data) => api.post('/templates/bulk/generate-samples-via-workflow', data),
  bulkAddTags: (data) => api.put('/templates/bulk/add-tags', data),

  // AI generation
  generateDescription: (name) => api.post('/templates/generate-description', { name }),
  enhancePrompt: (prompt) => api.post('/templates/enhance-prompt', { prompt }),
  
  // History
  getHistory: (id) => api.get(`/templates/${id}/history`)
};

// Photo API
export const photoAPI = {
  getAll: (params = {}) => api.get('/photos', { params }),
  getById: (id) => api.get(`/photos/${id}`),
  getCategories: () => api.get('/photos/categories'),
  getRootCategories: () => api.get('/categories', { params: { type: 'photo', parentId: '' } }),
  getChildCategories: (parentId) => api.get('/categories', { params: { type: 'photo', parentId } }),
  upload: (formData, onUploadProgress) => api.post('/photos', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress,
  }),
  importFromUrl: (data) => api.post('/photos/import-from-url', data),
  update: (id, data) => api.put(`/photos/${id}`, data),
  delete: (id) => api.delete(`/photos/${id}`),
  // Tag management
  getAllTags: () => api.get('/photos/tags'),
  bulkAddTags: (photoIds, tags) => api.post('/photos/bulk/add-tags', { photo_ids: photoIds, tags }),
  bulkRemoveTags: (photoIds, tags) => api.post('/photos/bulk/remove-tags', { photo_ids: photoIds, tags }),
  bulkUpdateCategory: (photoIds, categoryId, subcategoryId) => api.post('/photos/bulk/update-category', { photo_ids: photoIds, category_id: categoryId, subcategory_id: subcategoryId }),
  mergeTag: (sourceTagId, targetTagId) => api.post(`/photos/tags/${sourceTagId}/merge`, { target_tag_id: targetTagId }),
  setParentTag: (tagId, parentId) => api.post(`/photos/tags/${tagId}/parent`, { parent_id: parentId }),
  getTagHierarchy: () => api.get('/photos/tags/hierarchy'),
  removeParentTag: (tagId) => api.delete(`/photos/tags/${tagId}/parent`),
  // Thumbnail generation
  getPhotosWithoutThumbnails: (params = {}) => api.get('/photos/without-thumbnails', { params }),
  generateThumbnail: (photoId) => api.post(`/photos/${photoId}/generate-thumbnail`),
  bulkGenerateThumbnails: () => api.post('/photos/bulk/generate-thumbnails'),
};

// Graphic API
export const graphicAPI = {
  getAll: (params = {}) => api.get('/graphics', { params }),
  getById: (id) => api.get(`/graphics/${id}`),
  getCategories: () => api.get('/graphics/categories'),
  getDefaults: () => api.get('/graphics/defaults'),
  getDev: () => api.get('/graphics/dev'),
  create: (data) => api.post('/graphics', data),
  update: (id, data) => api.put(`/graphics/${id}`, data),
  delete: (id) => api.delete(`/graphics/${id}`),
};


// Audio API
export const audioAPI = {
  getAll: (params = {}) => api.get('/audio', { params }),
  getById: (id) => api.get(`/audio/${id}`),
  getCategories: () => api.get('/audio/categories'),
  upload: (formData) => api.post('/audio', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  generatePreviewAudio: (payload) => api.post('/preview/generate-preview-audio', payload, {
    responseType: 'blob',
    timeout: 300000 // 5 minutes for audio processing
  }),
  update: (id, data) => api.put(`/audio/${id}`, data),
  delete: (id) => api.delete(`/audio/${id}`),
  download: (id) => api.get(`/audio/${id}/download`, { responseType: 'blob' })
};

// Sound Effects API
export const soundEffectAPI = {
  getAll: (params = {}) => api.get('/sound-effects/', { params }),
  getById: (id) => api.get(`/sound-effects/${id}`),
  getCategories: () => api.get('/sound-effects/categories/'),
  upload: (formData) => api.post('/sound-effects/', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  update: (id, data) => api.put(`/sound-effects/${id}`, data),
  delete: (id) => api.delete(`/sound-effects/${id}`),
  download: (id) => api.get(`/sound-effects/${id}/download`, { responseType: 'blob' })
};

// Video API
export const videoAPI = {
  getAll: (params = {}) => api.get('/videos', { params }),
  getById: (id) => api.get(`/videos/${id}`),
  getCategories: () => api.get('/videos/categories'),
  upload: (formData) => api.post('/videos', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  importFromUrl: (formData) => api.post('/videos/import-from-url', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  update: (id, data) => api.put(`/videos/${id}`, data),
  delete: (id) => api.delete(`/videos/${id}`),
  download: (id) => api.get(`/videos/${id}/download`, { responseType: 'blob' })
};

// Overlay Video API
export const overlayVideoAPI = {
  getAll: (params = {}) => api.get('/overlay-videos', { params }),
  getById: (id) => api.get(`/overlay-videos/${id}`),
  upload: (formData) => api.post('/overlay-videos', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  delete: (id) => api.delete(`/overlay-videos/${id}`),
  getThumbnail: (id) => api.get(`/overlay-videos/${id}`, { responseType: 'blob' })
};

// Category API
export const categoryAPI = {
  getAll: (params = {}) => api.get('/categories', { params }),
  getById: (id) => api.get(`/categories/${id}`),
  create: (data) => api.post('/categories', data),
  update: (id, data) => api.put(`/categories/${id}`, data),
  delete: (id) => api.delete(`/categories/${id}`),
  getSubCategories: (parentId) => api.get('/categories', { params: { parent_id: parentId } }),
  getTree: () => api.get('/categories', { params: { tree: true } }),
  search: (query, params = {}) => api.get('/categories/search', { params: { q: query, ...params } }),
};

// Field Sample Sets API
export const fieldSampleSetAPI = {
  getAll: (params = {}) => api.get('/field-sample-sets', { params }),
  getGroups: () => api.get('/field-sample-sets/groups'),
  getById: (id) => api.get(`/field-sample-sets/${id}`),
  create: (data) => api.post('/field-sample-sets', data),
  update: (id, data) => api.put(`/field-sample-sets/${id}`, data),
  delete: (id) => api.delete(`/field-sample-sets/${id}`),
};

// Auth API
export const authAPI = {
  login: (email, password, deviceFingerprint = null) => api.post('/auth/login', { email, password, deviceFingerprint }),
  verifyOTPLogin: (email, otp, location, deviceFingerprint = null) => api.post('/auth/login/verify-otp', { email, otp, location, deviceFingerprint }),
  register: (userData) => api.post('/auth/register', userData),
  requestPasswordReset: (email) => api.post('/auth/password/request-reset', { email }),
  resetPassword: (token, password) => api.post('/auth/password/reset', { token, password }),
  sendOTP: (mobile) => api.post('/auth/send-otp', { mobile }),
  verifyOTP: (data) => api.post('/auth/verify-otp', data),
  refreshToken: () => api.post('/auth/refresh'),
  logout: () => api.post('/auth/logout'),
};

// Device API
export const deviceAPI = {
  getMyDevices: () => api.get('/devices/my-devices'),
  trustDevice: (deviceId) => api.post(`/devices/trust/${deviceId}`),
  untrustDevice: (deviceId) => api.post(`/devices/untrust/${deviceId}`),
  removeDevice: (deviceId) => api.delete(`/devices/${deviceId}`),
  updateDeviceName: (deviceId, deviceName) => api.put(`/devices/${deviceId}/name`, { deviceName }),
};

// User API
export const userAPI = {
  getAll: (params = {}) => api.get('/users', { params }),
  getById: (id) => api.get(`/users/${id}`),
  create: (data) => api.post('/users', data),
  update: (id, data) => api.put(`/users/${id}`, data),
  delete: (id) => api.delete(`/users/${id}`),
  getProfile: () => api.get('/users/profile'),
  updateProfile: (data) => api.put('/users/profile', data),
};

// Project API
export const projectAPI = {
  getAll: (params = {}) => api.get('/projects', { params }),
  getById: (id) => api.get(`/projects/${id}`),
  create: (data) => api.post('/projects', data),
  update: (id, data) => api.put(`/projects/${id}`, data),
  delete: (id) => api.delete(`/projects/${id}`),
  duplicate: (id) => api.post(`/projects/${id}/duplicate`),
};

// Notification API
export const notificationAPI = {
  getAll: (params = {}) => api.get('/notifications', { params }),
  getUnreadCount: () => api.get('/notifications/unread-count'),
  markAsRead: (id) => api.put(`/notifications/${id}/read`),
  markAllAsRead: () => api.put('/notifications/mark-all-read'),
  delete: (id) => api.delete(`/notifications/${id}`),
  clearAll: () => api.delete('/notifications'),
  // Admin functions
  createSystem: (data) => api.post('/notifications/system', data),
  createUser: (data) => api.post('/notifications/user', data),
  getAllAdmin: (params = {}) => api.get('/notifications/admin/all', { params }),
};

// Tenant API
export const tenantAPI = {
  getAll: (params = {}) => api.get('/tenants', { params }),
  getById: (id) => api.get(`/tenants/${id}`),
  create: (data) => api.post('/tenants', data),
  update: (id, data) => api.put(`/tenants/${id}`, data),
  softDelete: (id) => api.delete(`/tenants/${id}`),
  restore: (id) => api.post(`/tenants/${id}/restore`),
  updateChangeTriggerUrl: (id, data) => api.put(`/tenants/${id}/change-trigger-url`, data),
  getChangeTriggerUrl: (id) => api.get(`/tenants/${id}/change-trigger-url`),
};



// Sample Values Set API
export const sampleValuesSetAPI = {
  getAll: (params = {}) => api.get('/sample-values-sets', { params }),
  getById: (id) => api.get(`/sample-values-sets/${id}`),
  create: (data) => api.post('/sample-values-sets', data),
  update: (id, data) => api.put(`/sample-values-sets/${id}`, data),
  delete: (id) => api.delete(`/sample-values-sets/${id}`),
  getUniqueSampleSetCodes: () => api.get('/sample-values-sets/sample-set-codes/unique'),
  getUniqueLanguages: () => api.get('/sample-values-sets/languages/unique'),
  getBySampleSet: (sampleSetCode, language = null) => {
    const params = language ? { language } : {};
    return api.get(`/sample-values-sets/by-sample-set/${sampleSetCode}`, { params });
  },
  getByCategory: (category_id) => api.get(`/sample-values-sets/by-category/${category_id}`),
};

// Tenant Template API
export const tenantTemplateAPI = {
  getAll: (params = {}) => api.get('/tenant-templates', { params }),
  getForTenant: (tenantId, params = {}) => api.get(`/tenant-templates/tenant/${tenantId}`, { params }),
  assign: (data) => api.post('/tenant-templates', data),
  bulkAssign: (data) => api.post('/tenant-templates/bulk-assign', data),
  update: (id, data) => api.put(`/tenant-templates/${id}`, data),
  remove: (id) => api.delete(`/tenant-templates/${id}`),
};

// Tenant Watermark Template API
export const tenantWatermarkTemplateAPI = {
  getAll: (params = {}) => api.get('/tenant-watermark-templates', { params }),
  getById: (id) => api.get(`/tenant-watermark-templates/${id}`),
  getForTenant: (tenantId, params = {}) => api.get(`/tenant-watermark-templates/tenant/${tenantId}/watermarks`, { params }),
  create: (data) => api.post('/tenant-watermark-templates', data),
  update: (id, data) => api.put(`/tenant-watermark-templates/${id}`, data),
  delete: (id) => api.delete(`/tenant-watermark-templates/${id}`),
};

// Tools API
export const toolsAPI = {
  backgroundRemove: (file) => {
    const form = new FormData();
    form.append('image', file);
    return api.post('/tools/background-remove', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
      responseType: 'blob',
    });
  },
};

// Background Removal API
export const backgroundRemovalAPI = {
  dualProcess: (formData) => api.post('/background-removal/dual-process', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  upload: (formData) => api.post('/background-removal/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    responseType: 'blob',
  }),
};

// Vector Graphics API
export const vectorGraphicAPI = {
  getAll: (params = {}) => api.get('/vector-graphics', { params }),
  getById: (id) => api.get(`/vector-graphics/${id}`),
  getCategories: () => api.get('/vector-graphics/categories'),
  getByCategory: (category) => api.get(`/vector-graphics/category/${category}`),
  search: (params = {}) => api.get('/vector-graphics/search', { params }),
  getPropertiesSchema: () => api.get('/vector-graphics/properties-schema'),
};

// Mask Assets API
export const maskAssetAPI = {
  list: (params = {}) => api.get('/mask-assets', { params }),
  upload: (formData) => api.post('/mask-assets', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  delete: (id) => api.delete(`/mask-assets/${id}`),
};

// Catalog API
export const catalogAPI = {
  getFonts: () => api.get('/catalog/fonts'),
  getShapes: (params = {}) => api.get('/catalog/shapes', { params }),
  getWordArt: () => api.get('/catalog/wordart'),
  getWordArt3D: () => api.get('/catalog/wordart-3d'),
};

// Export the configured axios instance as default
export default api;

// Category Fields API (Legacy)
export const categoryFieldAPI = {
  getAll: () => api.get('/category-fields'),
  listForCategory: (category_id, params = {}) => api.get(`/category-fields/category/${category_id}`, { params }),
  getById: (id) => api.get(`/category-fields/${id}`),
  create: (data) => api.post('/category-fields', data),
  update: (id, data) => api.put(`/category-fields/${id}`, data),
  delete: (id) => api.delete(`/category-fields/${id}`),
};

// Simplified Category Fields API (Global Field References Only)
export const simplifiedCategoryFieldAPI = {
  // Assign/unassign global fields
  assignGlobalField: (data) => api.post('/simplified-category-fields/assign', data),
  unassignGlobalField: (category_id, global_field_id) =>
    api.delete(`/simplified-category-fields/unassign/${category_id}/${global_field_id}`),

  // Update field properties
  updateRequirement: (category_field_id, data) =>
    api.put(`/simplified-category-fields/requirement/${category_field_id}`, data),

  // Get fields
  getCategoryFields: (category_id, params = {}) =>
    api.get(`/simplified-category-fields/category/${category_id}`, { params }),
  getAvailableFields: (category_id, params = {}) =>
    api.get(`/simplified-category-fields/available/${category_id}`, { params }),
  getFieldSummary: (category_id, params = {}) =>
    api.get(`/simplified-category-fields/category/${category_id}/summary`, { params }),

  // Bulk operations
  bulkAssignFields: (data) => api.post('/simplified-category-fields/bulk-assign', data),
  reorderFields: (data) => api.put('/simplified-category-fields/reorder', data),
};

// Global Category Fields API
export const globalCategoryFieldAPI = {
  // User endpoints
  getAll: (params = {}) => api.get('/global-category-fields/', { params }),
  getById: (id, params = {}) => api.get(`/global-category-fields/${id}`, { params }),
  getByKey: (key, params = {}) => api.get(`/global-category-fields/key/${key}`, { params }),
  getPopular: (params = {}) => api.get('/global-category-fields/popular', { params }),
  getSupportedLanguages: () => api.get('/global-category-fields/languages'),
  incrementUsage: (id) => api.post(`/global-category-fields/${id}/increment-usage`),

  // Admin endpoints
  create: (data) => api.post('/global-category-fields/', data),
  update: (id, data) => api.put(`/global-category-fields/${id}`, data),
  delete: (id) => api.delete(`/global-category-fields/${id}`),
  createDefaults: () => api.post('/global-category-fields/bulk/create-defaults'),
};

// Export API with extended timeouts for image generation
export const exportAPI = {
  download: (data) => api.post('/export/download', data, {
    responseType: 'blob',
    timeout: 1000000 // 5 minutes for complex templates
  }),
  downloadCurrent: (data) => api.post('/export/download-current', data, {
    responseType: 'blob',
    timeout: 1000000 // 5 minutes for complex templates
  }),
  downloadFull: (data) => api.post('/export/download-full', data, {
    responseType: 'blob',
    timeout: 1000000 // 5 minutes for complex templates
  }),
};

// Import API with extended timeouts for large files
export const importAPI = {
  pdf: (formData) => api.post('/import/pdf', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 600000 // 10 minutes for PDF import
  }),
  psd: (formData) => api.post('/import/psd', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 600000 // 10 minutes for PSD import
  }),
  powerpoint: (formData) => api.post('/import/powerpoint', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 600000 // 10 minutes for PowerPoint import
  }),
  cdr: (formData) => api.post('/import/cdr', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 600000 // 10 minutes for CDR import
  }),
  getSupportedFormats: () => api.get('/import/supported-formats'),
};


// Multi Template Generator API
export const multiTemplateGeneratorAPI = {
  getAll: (params = {}) => api.get('/multi-template-generator/', { params }),
  getById: (id) => api.get(`/multi-template-generator/${id}`),
  getGroups: () => api.get('/multi-template-generator/groups'),
  getByGroup: (group, params = {}) => api.get(`/multi-template-generator/group/${group}`, { params }),
  create: (data) => api.post('/multi-template-generator/', data),
  update: (id, data) => api.put(`/multi-template-generator/${id}`, data),
  delete: (id) => api.delete(`/multi-template-generator/${id}`),
  deleteGroup: (group) => api.delete(`/multi-template-generator/group/${group}`),
  toggleActive: (id) => api.put(`/multi-template-generator/${id}/toggle-active`)
}

// AI Generator API
export const aiGeneratorAPI = {
  // Generators
  getAll: (params = {}) => api.get('/ai-generators/', { params }),
  getById: (id) => api.get(`/ai-generators/${id}`),
  create: (data) => api.post('/ai-generators/', data),
  update: (id, data) => api.put(`/ai-generators/${id}`, data),
  delete: (id) => api.delete(`/ai-generators/${id}`),

  // Knowledgebase
  getKnowledgebase: (generatorId) => api.get(`/ai-generators/${generatorId}/knowledgebase`),
  createKnowledgebase: (generatorId, data) => api.post(`/ai-generators/${generatorId}/knowledgebase`, data),
  updateKnowledgebase: (id, data) => api.put(`/ai-generators/knowledgebase/${id}`, data),
  deleteKnowledgebase: (id) => api.delete(`/ai-generators/knowledgebase/${id}`),

  // Fields
  getFields: (generatorId) => api.get(`/ai-generators/${generatorId}/fields`),
  createField: (generatorId, data) => api.post(`/ai-generators/${generatorId}/fields`, data),
  updateField: (id, data) => api.put(`/ai-generators/fields/${id}`, data),
  deleteField: (id) => api.delete(`/ai-generators/fields/${id}`),

  // Executors
  getExecutors: (params = {}) => api.get('/ai-generators/executors/list', { params }),
  getExecutor: (id) => api.get(`/ai-generators/executors/${id}`),
  createExecutor: (data) => api.post('/ai-generators/executors', data),
  updateExecutor: (id, data) => api.put(`/ai-generators/executors/${id}`, data),
  deleteExecutor: (id) => api.delete(`/ai-generators/executors/${id}`),

  // Executor Fields
  getExecutorFields: (executorId) => api.get(`/ai-generators/executors/${executorId}/fields`),
  updateExecutorField: (id, data) => api.put(`/ai-generators/executor-fields/${id}`, data),

  // Pipeline - Run & Sync
  runGenerator: (generatorId, data) => api.post(`/ai-generators/${generatorId}/run`, data),
  syncExecutor: (executorId) => api.get(`/ai-generators/executors/${executorId}/sync`),
  retryExecutor: (executorId) => api.post(`/ai-generators/executors/${executorId}/retry`),
  // Partial retry: re-run a single failed image field
  retryExecutorField: (executorId, fieldId) => api.post(`/ai-generators/executors/${executorId}/fields/${fieldId}/retry`),
  // Bulk sync / retry across selected executors
  bulkSyncExecutors: (ids) => api.post('/ai-generators/executors/bulk-sync', { ids }),
  bulkRetryExecutors: (ids) => api.post('/ai-generators/executors/bulk-retry', { ids }),

  // Approval workflow
  approveExecutor: (executorId) => api.post(`/ai-generators/executors/${executorId}/approve`),
  denyExecutor: (executorId) => api.post(`/ai-generators/executors/${executorId}/deny`),

  // Delete executor (optionally with its generated template)
  deleteExecutorWithTemplate: (executorId) => api.delete(`/ai-generators/executors/${executorId}`, { params: { delete_template: true } }),

  // Bulk delete executors (optionally with their generated templates)
  bulkDeleteExecutors: (ids, deleteTemplate = false) => api.post('/ai-generators/executors/bulk-delete', { ids, delete_template: deleteTemplate }),

  // Clone
  clone: (id) => api.post(`/ai-generators/${id}/clone`),

  // Hourly stats
  getHourlyStats: (tzOffset = 330) => api.get('/ai-generators/stats/hourly', { params: { tz_offset: tzOffset } }),

  // Design Templates (design template IDs + tags)
  getTemplates: (generatorId) => api.get(`/ai-generators/${generatorId}/templates`),
  createTemplate: (generatorId, data) => api.post(`/ai-generators/${generatorId}/templates`, data),
  updateTemplate: (id, data) => api.put(`/ai-generators/templates/${id}`, data),
  deleteTemplate: (id) => api.delete(`/ai-generators/templates/${id}`),
}
